import { render, staticRenderFns } from "./ShoppingCartItem.vue?vue&type=template&id=8f4aa68e"
import script from "./ShoppingCartItem.vue?vue&type=script&lang=js"
export * from "./ShoppingCartItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports